import styled from 'styled-components';
import NativeLink from '../../../../common/NativeLink';

const IneligibleAccountDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  padding: 30px 25px;
  align-items: center;
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    padding: 45px 80px;
  }
`;

const Title = styled.h2`
  ${(props) => props.theme.font.heading.v100};
  color: ${(props) => props.theme.color.primary.v600};
  margin: 10px 0 10px;
  text-align: center;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: ${(props) => props.theme.font.weight.v100};
  ${(props) => props.theme.font.body.v200};
  margin: 5px 0;
  text-align: center;
  white-space: pre-line;

  strong {
    font-weight: bold;
  }

  p {
    margin-bottom: 0;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    width: 100%;
    ${(props) => props.theme.font.body.v300};
  }
`;

const HyperLink = styled(NativeLink)`
  color: ${(props) => props.theme.color.primary.v200};
  text-decoration: underline;
  font-weight: bold;
`;

export { IneligibleAccountDetailsWrapper, Title, Body, HyperLink };
